// extracted by mini-css-extract-plugin
module.exports = {"recovery":"resetPassword_recovery__161-_","moveIcon":"resetPassword_moveIcon__tclEQ"};